<div role="dialog" aria-labelledby="dialogTitle">
  <div class="modal-header">
    <h2 id="dialogTitle" class="modal-title module-title">{{"plan.convert.title"|translate}}</h2>
    <button [disabled]="!_enableCancel" type="button" class="close" [attr.aria-label]="'plan.convert.close.aria' | translate"
            title="{{'plan.convert.close.aria'|translate}}"
            (click)="dismiss()">
      <!-- WCAG 4.1.2 Name, Role, Value / Dragon voice control: the icon-only
           close control is a native <button> so it exposes the implicit "button"
           role, and its accessible name comes from a single authoritative source
           - the descriptive, unique aria-label ("Close Convert to Active Forecast
           dialog"). Dragon voice users say that phrase (or "Close dialog") to
           activate it, so it never collides with Dragon's global "Close" window
           command. The glyph is aria-hidden so it cannot supply a competing name,
           and no visually-hidden text duplicate is rendered: an off-screen
           .sr-only copy of the name created a SECOND matchable target at an
           off-screen position, so Dragon could click the empty off-screen node
           (activating nothing) and fall back to closing the browser. -->
      <esp-icon name="x"></esp-icon>
    </button>
  </div>
  <div class="modal-body convert-modal-body">
    <wfm-plan-loading-overlay *ngIf="_isLoading"></wfm-plan-loading-overlay>

    <div class="col-12">
      <form #planSettingsForm="ngForm" (submit)="submit()">
        <div class="row group-title">
          <div class='col-12'>
            <span class="primary-text">{{planName}}</span>
          </div>
        </div>
        <div class="row">
          <div class='col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 '>
            <div>
              <label class="input-label" for="sourceFrom">
                {{"plan.convert.from"|translate}} <span class="text-danger">*</span>
              </label>
            </div>
            <p-datepicker class="wfm-form-control form-control-inline"
                        name="sourceFrom"
                        #sourceFromCalendarEl
                        inputId="sourceFrom"
                        [showIcon]="true"
                        [showOnFocus]="false"
                        [minDate]="_planStartDate"
                        [maxDate]="_planEndDate"
                        [keepInvalid]="true"
                        [showOtherMonths]="true"
                        (onClose)="onSourceFromChanged()"
                        (onInput)="onSourceFromChanged()"
                        (onSelect)="onSourceFromChanged()"
                        [dateFormat]="_datesFormat"
                        readonlyInput="true"
                        [(ngModel)]="_sourceFrom">
            </p-datepicker>
            <div *ngIf="_showSourceFromValidationError" class="error-message">
              {{'plan.convert.source.from.validation'|translate}}
            </div>
          </div>
        </div>
        <div class="row">
          <div class='col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 '>
            <div>
              <label class="input-label" for="sourceTo">
                {{"plan.convert.to"|translate}} <span class="text-danger">*</span>
              </label>
            </div>
            <p-datepicker class="wfm-form-control form-control-inline"
                        name="sourceTo"
                        #sourceToCalendarEl
                        inputId="sourceTo"
                        [showIcon]="true"
                        [showOnFocus]="false"
                        [minDate]="_planStartDate"
                        [keepInvalid]="true"
                        [maxDate]="_planEndDate"
                        (onClose)="onSourceToChanged()"
                        (onInput)="onSourceToChanged()"
                        (onSelect)="onSourceToChanged()"
                        [dateFormat]="_datesFormat"
                        readonlyInput="true"
                        [(ngModel)]="_sourceTo">
            </p-datepicker>
            <div *ngIf="_showSourceToValidationError" class="error-message">
              {{'plan.convert.source.to.validation'|translate}}
            </div>
            <div *ngIf="_showSourceToRangeValidationError" class="error-message">
              {{'plan.convert.source.to.range.validation'|translate}}
            </div>
          </div>
        </div>
        <div class="row separator">

        </div>
        <div class="row  group-title">
          <div class='col-12'>
            <span class="primary-text">{{"plan.convert.active.forecast.label"|translate}}</span>
          </div>
        </div>
        <div class="row">
          <div class='col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 '>
            <div>
              <label class="input-label" for="targetFrom">
                {{"plan.convert.from"|translate}} <span class="text-danger">*</span>
              </label>
            </div>
            <p-datepicker class="wfm-form-control form-control-inline"
                        name="targetFrom"
                        #targetFromCalendarEl
                        inputId="targetFrom"
                        [showIcon]="true"
                        [showOnFocus]="false"
                        [minDate]="_targetFromMin"
                        [keepInvalid]="true"
                        (onInput)="onTargetFromChanged()"
                        (onSelect)="onTargetFromChanged()"
                        [dateFormat]="_datesFormat"
                        readonlyInput="true"
                        [(ngModel)]="_targetFrom">
            </p-datepicker>
            <div *ngIf="_showTargetFromValidationError" class="error-message">
              {{'plan.convert.target.from.validation'|translate}}
            </div>
          </div>
        </div>
        <div class="row">
          <div class='col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 '>
            <div>
              <label class="input-label" for="targetTo">
                {{"plan.convert.to"|translate}}
              </label>
            </div>
            <p-datepicker class="wfm-form-control form-control-inline"
                        name="targetTo"
                        inputId="targetTo"
                        [showIcon]="true"
                        [showOnFocus]="false"
                        [disabled]="true"
                        [dateFormat]="_datesFormat"
                        [(ngModel)]="_targetTo">
            </p-datepicker>
          </div>
        </div>
        <div class="row warning-message" [ngClass]="{'invisible':_forecastIsSameDay}">
          <div class='col-12'>
            <span>
              <esp-icon class="warning-icon" name="warning"></esp-icon>
              {{"plan.convert.warning.date.range.begin.diff.days"|translate}}
            </span>
          </div>
        </div>

      </form>
    </div>
  </div>
  <div class="modal-footer">
    <div class="modal-buttons">
      <breeze-button buttonText="{{'plan.cancel.btn'|translate}}"
                     id="cancel-btn"
                     [isSecondary]="true"
                     [isDisabled]="!_enableCancel"
                     [showTooltip]="true"
                     (clicked)="dismiss()"></breeze-button>

      <breeze-button buttonText="{{'plan.convert.btn'|translate}}"
                     id="accept-btn"
                     [isPrimary]="true"
                     [isDisabled]="!_enableAccept"
                     [showTooltip]="true"
                     placement="top"
                     [ngbPopover]="convertPlanMsg"></breeze-button>
    </div>
  </div>
</div>
<ng-template #convertPlanMsg>
  <div class="message-delete">
    <p>{{warningMessageText()}} </p>
  </div>
  <div class="button-response">
    <breeze-button [isSecondary]="true" buttonText="{{'btn.cancel.label' | translate }}"></breeze-button>
    <breeze-button [isPrimary]="true" buttonText="{{'btn.confirm.label' | translate }}" (clicked)="submit()"></breeze-button>
  </div>
</ng-template>
